// extracted by mini-css-extract-plugin
export default {"text-input":"TextInput_text-input__vn1O1"};